// Signals the token-exchange page to reuse the register session and skip INT116.
export const REGISTER_CTA_QUERY_PARAM = 'fromRegister';

export const appendRegisterCtaParam = (url?: string): string => {
  if (!url) return url ?? '';
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${REGISTER_CTA_QUERY_PARAM}=true`;
};

export const hasCameFromRegisterCta = (): boolean =>
  new URLSearchParams(globalThis.location.search).get(REGISTER_CTA_QUERY_PARAM) === 'true';
